import * as ukModules from './uk/modules';
import * as seModules from './se/modules';

export const uk = ukModules;
export const se = seModules;
